import React from 'react';
import PropTypes from 'prop-types';

// Components
import Badge from '../../atoms/Badge/Badge';
import IconAction from '../../atoms/IconAction/IconAction';

// Utils
import cn from '../../utils/cn';

import style from './Card.module.css';

const Card = ({
  className, image, imageAction, tags, title, subtitle, children, footer,
}) => (
  <article className={cn([style.card, className])}>
    {image || imageAction
      ? (
        <div className={style.imageBlock}>
          {image ? <img className={style.image} src={image.src} alt={image.alt} /> : null}
          {imageAction
            ? (
              <IconAction
                onClick={imageAction.onClick}
                icon={imageAction.icon}
                color={imageAction.color}
                isActive={imageAction.isActive}
                activeIcon={imageAction.activeIcon}
                activeColor={imageAction.activeColor}
                className={style.imageAction}
              />
            )
            : null}
        </div>
      )
      : null}

    <div className={style.content}>
      {tags
        ? (
          <ul className={style.tagsList}>
            {tags.map((tag) => (
              <li className={style.tagsListItem}>
                <Badge size="small" label={tag.label} color={tag.color} />
              </li>
            ))}
          </ul>
        )
        : null}
      <p className={style.title}>{title}</p>
      {subtitle ? <p className={style.subtitle}>{subtitle}</p> : null}
      {children ? <div className={style.children}>{children}</div> : null}
    </div>

    {footer ? <div>{footer}</div> : null}
  </article>
);

Card.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }),
  imageAction: PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.string.isRequired,
    color: PropTypes.string,
    isActive: PropTypes.bool,
    activeIcon: PropTypes.string,
    activeColor: PropTypes.string,
  }),
  tags: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  })),
  children: PropTypes.node,
  footer: PropTypes.node,
  className: PropTypes.string,
};

Card.defaultProps = {
  subtitle: null,
  image: null,
  imageAction: null,
  tags: null,
  children: null,
  footer: null,
  className: null,
};

export default Card;
